(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!host || !host.document || host.__CL_HEAD_TRIP_COUNTDOWN__) return;
  host.__CL_HEAD_TRIP_COUNTDOWN__ = true;
  var doc = host.document, instances = new Map();
  function initialize(scope) {
    scope.querySelectorAll('[data-cl-head-trip-countdown],[data-cl-access-start]').forEach(function (element) {
      if (instances.has(element)) return;
      var isBanner = element.hasAttribute('data-cl-head-trip-countdown');
      var zone = element.getAttribute('data-time-zone') || 'America/Los_Angeles';
      var start = isBanner && element.hasAttribute('data-start-date') ? api.parseLocalStart(element.getAttribute('data-start-date'), element.getAttribute('data-start-time'), zone) : api.parseStart(element.getAttribute(isBanner ? 'data-starts-at' : 'data-cl-access-start'));
      var lastState = '', timer = null;
      function update() {
        if (!element.isConnected) { stop(); return; }
        var current = api.stateAt(start, Date.now());
        element.hidden = current.state === 'expired' || current.state === 'invalid';
        var entrance = element.closest('cl-entry-gate');
        if (entrance && isBanner) {
          var placement = element.closest('.cl-entry__countdown');
          if (placement) placement.hidden = element.hidden;
          entrance.classList.toggle('cl-entry--countdown', !element.hidden);
        }
        if (!isBanner) {
          if (current.state === 'open' && lastState !== 'open') {
            var title = element.querySelector('h2'); if (title) title.textContent = 'ACCESS OPEN';
          }
          lastState = current.state;
          if (element.hidden) stop();
          return;
        }
        element.dataset.state = current.state;
        if (element.hidden) { stop(); return; }
        var digits = element.querySelector('[data-countdown-digits]');
        digits.hidden = current.state !== 'before';
        if (current.state === 'before') {
          ['days','hours','minutes','seconds'].forEach(function (key) { element.querySelector('[data-countdown-' + key + ']').textContent = String(current[key]).padStart(2, '0'); });
        }
        if (lastState !== current.state) {
          var labels = api.formatInZone(start, zone);
          element.querySelector('[data-countdown-date]').textContent = labels.date;
          element.querySelector('[data-countdown-date]').setAttribute('datetime', new Date(start).toISOString());
          element.querySelector('[data-countdown-time]').textContent = labels.time;
          element.querySelector('[data-countdown-heading]').textContent = element.getAttribute(current.state === 'open' ? 'data-open-copy' : 'data-before-copy');
          element.querySelector('[data-countdown-status]').textContent = current.state === 'open' ? element.getAttribute('data-status-open') : element.getAttribute('data-status-before') + ' ' + labels.date + ' / ' + labels.time + '.';
          lastState = current.state;
        }
      }
      function stop() { if (timer !== null) host.clearInterval(timer); timer = null; doc.removeEventListener('visibilitychange', update); instances.delete(element); }
      instances.set(element, stop);
      update();
      if (instances.has(element)) { timer = host.setInterval(update, 1000); doc.addEventListener('visibilitychange', update); }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initialize(doc); }, { once: true }); else initialize(doc);
  doc.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  doc.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (stop, element) { if (event.target.contains(element)) stop(); }); });
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var DURATION = 60 * 60 * 1000;
  function parseStart(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
    var instant = Date.parse(value);
    if (!Number.isFinite(instant)) return NaN;
    var clockParts = value.slice(11,19).split(':').map(function (part) { return parseInt(part, 10); });
    if (clockParts[0] > 23 || clockParts[1] > 59 || (clockParts.length > 2 && clockParts[2] > 59)) return NaN;
    var dateParts = value.slice(0,10).split('-').map(Number);
    var daysInMonth = new Date(Date.UTC(dateParts[0], dateParts[1], 0)).getUTCDate();
    if (dateParts[1] < 1 || dateParts[1] > 12 || dateParts[2] < 1 || dateParts[2] > daysInMonth) return NaN;
    return instant;
  }
  function parseLocalStart(date, time, zone) {
    if (typeof date !== 'string' || typeof time !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time)) return NaN;
    var target = parseStart(date + 'T' + time + ':00Z');
    if (!Number.isFinite(target)) return NaN;
    try {
      var formatter = new Intl.DateTimeFormat('en-US', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      function localEpoch(instant) {
        var values = {};
        formatter.formatToParts(instant).forEach(function (part) { values[part.type] = part.value; });
        return Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), Number(values.hour), Number(values.minute), Number(values.second));
      }
      var result = target;
      for (var attempt = 0; attempt < 4; attempt += 1) result += target - localEpoch(result);
      return localEpoch(result) === target ? result : NaN;
    } catch (_) { return NaN; }
  }
  function stateAt(start, now) {
    if (!Number.isFinite(start) || !Number.isFinite(now)) return { state: 'invalid' };
    if (now >= start + DURATION) return { state: 'expired' };
    if (now >= start) return { state: 'open' };
    var remaining = Math.ceil((start - now) / 1000);
    return { state: 'before', days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
  }
  function formatInZone(start, zone) {
    var date = new Intl.DateTimeFormat('en-US', { timeZone: zone, month: 'long', day: 'numeric', year: 'numeric' }).format(start).toUpperCase();
    var zoneLabel = { 'America/Los_Angeles': 'PACIFIC', 'America/New_York': 'EASTERN', 'Europe/London': 'LONDON', 'UTC': 'UTC' }[zone] || zone;
    var time = new Intl.DateTimeFormat('en-US', { timeZone: zone, hour: 'numeric', minute: '2-digit', hour12: true }).format(start).replace(':00', '').replace(/\s/g, '').toUpperCase() + ' ' + zoneLabel;
    return { date: date, time: time };
  }
  function formatPacific(start) { return formatInZone(start, 'America/Los_Angeles'); }
  return { parseStart: parseStart, parseLocalStart: parseLocalStart, stateAt: stateAt, formatInZone: formatInZone, formatPacific: formatPacific, duration: DURATION };
});
